{
  "name": "@szn/ribbon",
  "version": "4.2.2",
  "description": "",
  "scripts": {
    "dev": "merkur dev",
    "build": "merkur build",
    "start": "merkur start",
    "test": "npm run build && npm run test:all",
    "test:unit": "cross-env TEST_GROUP='unit' merkur test",
    "test:integration": "npm run build && cross-env TEST_GROUP='integration' merkur test",
    "test:all": "npm run build && cross-env TEST_GROUP='all' merkur test",
    "test:watch": "cross-env TEST_GROUP='unit' merkur test --watchAll",
    "test:es-check": "es-check es9 ./build/static/es9/**/*.js && es-check es11 ./build/static/es11/**/*.js",
    "lint": "eslint --cache --cache-location=node_modules/.cache/  -c ../../.eslintrc.js './**/*.{js,ts,tsx,jsx}'",
    "legacy": "WIDGET_LEGACY=1 npm run dev",
    "rebuild": "rm -rf ./build && npm run build",
    "preversion": "npm run lint; npm run stylelint; npm run test:all",
    "postversion": "node ./tools/postVersion.js",
    "stylelint": "stylelint --cache --cache-location=node_modules/.cache/ --config ../../stylelint.config.js 'src/**/*.less'",
    "reinstall": "rm package-lock.json ; rm -rf node_modules/ ; npm install",
    "snapix:test:ci": "snapix test",
    "snapix:update": "snapix update",
    "snapix:report:clear": "rm -rf .snapix/report .snapix/artifact",
    "snapix:report": "npm run snapix:report:clear && usac artifact .snapix/artifact snapix && mv .snapix/artifact/snapix/apps/ribbon/.snapix/report .snapix/report && npx snapix-reporter-html",
    "storybook": "storybook dev -p 6006",
    "storybook:build": "storybook build"
  },
  "author": "",
  "license": "ISC",
  "dependencies": {
    "@esmj/monitor": "^0.5.3",
    "@ima/ip": "^1.2.1",
    "@ima/plugin-monitoring-common-metrics": "^2.0.2",
    "@ima/plugin-monitoring-kibana-logger": "^1.0.2",
    "@ima/plugin-monitoring-server": "^6.2.0",
    "@merkur/cli": "^0.36.3",
    "@merkur/core": "^0.36.0",
    "@merkur/integration": "^0.36.0",
    "@merkur/plugin-component": "^0.36.0",
    "@merkur/plugin-error": "^0.36.0",
    "@merkur/plugin-event-emitter": "^0.36.0",
    "@merkur/plugin-http-client": "^0.36.0",
    "@merkur/preact": "^0.36.0",
    "@noble/ed25519": "^1.7.3",
    "@szn/cache": "^3.1.1",
    "@szn/ribbon-schema": "*",
    "@szn/suggestlist": "2.6.2",
    "body-scroll-lock": "3.1.5",
    "classnames": "2.5.1",
    "compression": "1.7.4",
    "config": "^3.3.11",
    "cors": "2.8.5",
    "ejs": "^3.1.10",
    "express": "4.19.2",
    "express-static-gzip": "2.1.7",
    "helmet": "7.1.0",
    "infinite-ui-event": "1.0.3",
    "ioredis": "^5.4.1",
    "jsonschema": "1.4.1",
    "morgan": "1.10.0",
    "pg": "^8.11.5"
  },
  "devDependencies": {
    "@babel/preset-env": "^7.24.7",
    "@babel/preset-react": "^7.24.7",
    "@babel/preset-typescript": "^7.24.7",
    "@merkur/tool-storybook": "^0.36.0",
    "@merkur/tools": "0.36.0",
    "@snapix/cli": "3.4.0",
    "@snapix/storybook-integration": "3.4.0",
    "@storybook/addon-essentials": "^8.1.8",
    "@storybook/addon-queryparams": "^7.0.1",
    "@storybook/addon-styling-webpack": "^1.0.0",
    "@storybook/addon-webpack5-compiler-swc": "^1.0.3",
    "@storybook/preact": "^8.1.8",
    "@storybook/preact-webpack5": "^8.1.8",
    "@swc/core": "1.5.29",
    "@testing-library/preact": "^3.2.4",
    "@types/jest": "^29.5.12",
    "@types/pg": "^8.11.6",
    "@usa/cli": "^5.1.2",
    "babel-jest": "^29.7.0",
    "cross-env": "^7.0.3",
    "es-check": "^7.2.1",
    "esbuild-plugin-less": "^1.3.5",
    "identity-obj-proxy": "3.0.0",
    "jest": "^29.7.0",
    "picocolors": "1.0.1",
    "postcss-discard": "2.0.0",
    "postcss-prefixwrap": "^1.48.0",
    "request": "^2.88.2",
    "storybook": "^8.1.8",
    "storybook-addon-mock": "^5.0.0"
  },
  "overrides": {
    "react": "17",
    "react-dom": "17",
    "@swc/core": "1.5.29"
  }
}
